import { prompt, type PromptDefinition } from './models';

export const LAWYER_PROMPTS = [
    prompt(
        'Meet obligations',
        'Which orders or notices for this building need legal review?',
        'Which buildings have orders or notices to prioritise for legal review?'
    ),
    prompt(
        'Meet obligations',
        'What disputes are described in the available records for this building?',
        'Which buildings have documented disputes or unresolved legal correspondence?'
    ),
    prompt(
        'Meet obligations',
        "Which obligations and deadlines are recorded in this building's contracts?",
        'Which contractual deadlines across my buildings need legal attention first?'
    ),
    prompt(
        'Meet obligations',
        'Find legal correspondence for this building concerning…',
        'Find legal correspondence across my buildings concerning…',
        'prefill'
    ),
    prompt(
        'Meet obligations',
        'What title restrictions or easements are documented for this building?',
        'Compare documented title restrictions and easements across my buildings.'
    ),
    prompt(
        'Meet obligations',
        "Where do this building's contracts and supporting records conflict?",
        'Which buildings have conflicting contractual or supporting records?'
    ),
    prompt(
        'Meet obligations',
        "What does the available correspondence say about this building's dispute timeline?",
        'Which buildings have disputes with gaps in their documented timeline?'
    ),
    prompt(
        'Meet obligations',
        'Find contract clauses for this building relating to…',
        'Find contract clauses across my buildings relating to…',
        'prefill'
    ),
    prompt(
        'Meet obligations',
        "What evidence supports completion of this building's contractual obligations?",
        'Which buildings lack evidence that contractual obligations were completed?'
    ),
    prompt(
        'Manage risk',
        'What insurance and indemnity documents are available for this building?',
        'Which buildings have missing insurance or indemnity documents for legal review?'
    ),
    prompt(
        'Meet obligations',
        'Which documents should I request to complete legal due diligence on this building?',
        'Which buildings have the largest legal due-diligence evidence gaps?'
    ),
    prompt(
        'Meet obligations',
        "Trace the evidence for this building's legal issue involving…",
        'Compare legal evidence across my buildings involving…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
